import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const Shell = () => {
  return (
    <div className="tw-flex tw-min-h-screen tw-bg-rbah-off tw-text-rbah-ink">
      <Sidebar />
      <div className="tw-flex tw-flex-1 tw-flex-col">
        <Topbar />
        <main className="tw-flex-1 tw-p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Shell;
